import { ClassificationCard } from "@/app/activities/search/ClassificationCard";
import { Classification } from "@/types/classification";

type ClassificationSelectProps = {
    variant: "small" | "large";
    classifications: Classification[];
    selectedClassifications: Classification[];
    relevantButDisabledClassifications?: Classification[];
    disabledClassifications?: Classification[];
    invalidClassifications?: Classification[];
    onSelect: (classification: Classification, selected: boolean) => void;
    showIndexes?: boolean;
};

export const ClassificationSelect = ({
    variant,
    classifications,
    selectedClassifications,
    disabledClassifications,
    invalidClassifications,
    onSelect,
    showIndexes = false,
}: ClassificationSelectProps) => {
    const isClassificationSelected = (classification: Classification) => {
        return selectedClassifications
            ?.map((selectedClassification) => selectedClassification.id)
            .includes(classification.id);
    };

    const handleSelect = (classification: Classification) => {
        onSelect(
            classification,
            !selectedClassifications.includes(classification)
        );
    };

    return (
        <div
            className={`classification-select-${variant} flex ${
                variant === "small" ? "flex-row" : "flex-col"
            } flex-nowrap gap-2 w-full`}
        >
            {classifications?.map((classification) => {
                const isDisabled = disabledClassifications?.some(
                    (disabledClassification) =>
                        disabledClassification.id === classification.id
                );

                return (
                    <ClassificationCard
                        key={classification.id}
                        classification={classification}
                        index={
                            showIndexes &&
                            selectedClassifications
                                .map((s) => s.id)
                                .includes(classification.id)
                                ? selectedClassifications
                                      .map((s) => s.id)
                                      .indexOf(classification.id) + 1
                                : undefined
                        }
                        variant="buttons"
                        isSelected={isClassificationSelected(classification)}
                        onClick={
                            isDisabled
                                ? undefined
                                : () => handleSelect(classification)
                        }
                        state={isDisabled ? "disabled" : invalidClassifications?.some(
                            (invalidClassification) =>
                                invalidClassification.id === classification.id
                        ) ? "invalid" : "enabled"}
                    />
                );
            })}
        </div>
    );
};
